import React, { useEffect, useState } from 'react';
import { ArrowLeft, CirclePlay } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { getVideoEmbed, isDirectVideoUrl, loadPublicContent } from '../utils/siteContent';
import './PublicContentPage.css';

export function PublicContentPage({ type, title }) {
  const navigate = useNavigate();
  const [items, setItems] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [activeVideo, setActiveVideo] = useState(null);

  useEffect(() => {
    let isActive = true;
    loadPublicContent(type).then((content) => {
      if (isActive) {
        setItems(content);
        setIsLoading(false);
      }
    });
    return () => { isActive = false; };
  }, [type]);

  return (
    <main className="content-page-shell">
      <header className="content-page-header">
        <button className="content-back-button" type="button" aria-label="হোম পেইজে ফিরে যান" onClick={() => navigate('/')}>
          <ArrowLeft size={22} />
        </button>
        <img src="/logo.png" alt="Earneeds logo" />
        <span>Earneeds</span>
      </header>

      <section className="content-page-main">
        <div className="content-page-title-row">
          <p>Earneeds community</p>
          <h1>{title}</h1>
        </div>

        {isLoading ? (
          <p className="content-page-empty">লোড হচ্ছে...</p>
        ) : items.length === 0 ? (
          <p className="content-page-empty">এখনো কোনো {title} যোগ করা হয়নি।</p>
        ) : type === 'proofs' ? (
          <div className="content-proof-grid">
            {items.map((item) => (
              <a className="content-proof-card" href={item.imageUrl} target="_blank" rel="noreferrer" key={item.id}>
                <img src={item.imageUrl} alt={item.caption || 'Payment proof'} loading="lazy" />
                {item.caption && <span>{item.caption}</span>}
              </a>
            ))}
          </div>
        ) : type === 'reviews' ? (
          <div className="content-review-list">
            {items.map((item) => (
              <article className="content-review-card" key={item.id}>
                {item.profileUrl
                  ? <img src={item.profileUrl} alt="" loading="lazy" />
                  : <span className="content-review-fallback">{(item.name || '?').slice(0, 1)}</span>}
                <div>
                  <h2>{item.name}</h2>
                  <div className="content-review-stars" aria-label="5 stars">★★★★★</div>
                  <p>{item.text}</p>
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="content-video-list">
            {items.map((item) => (
              <button className="content-video-card" type="button" key={item.id} onClick={() => setActiveVideo(item)}>
                <CirclePlay size={28} aria-hidden="true" />
                <span>{item.title}</span>
              </button>
            ))}
          </div>
        )}
      </section>

      {activeVideo && (
        <div className="content-video-overlay" onClick={() => setActiveVideo(null)}>
          <section className="content-video-player" role="dialog" aria-modal="true" aria-label={activeVideo.title} onClick={(event) => event.stopPropagation()}>
            <div className="content-video-player-heading">
              <h2>{activeVideo.title}</h2>
              <button type="button" aria-label="ভিডিও বন্ধ করুন" onClick={() => setActiveVideo(null)}>×</button>
            </div>
            {isDirectVideoUrl(activeVideo.url)
              ? <video controls autoPlay src={activeVideo.url} />
              : <iframe title={activeVideo.title} src={getVideoEmbed(activeVideo.url)} allow="autoplay; encrypted-media; picture-in-picture" allowFullScreen />}
          </section>
        </div>
      )}
    </main>
  );
}
